import Controller, { inject as controller } from '@ember/controller';
import ProductActivationController from '../controller';
import FormValidations from 'cio/utils/form-validations';
import { ProductApp } from 'cio/utils/product-app-info';
import { task } from 'ember-concurrency';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import EnvironmentService from 'cio/services/environment';
import { announceHydraNavigate, announceRefreshAuth } from '@customerio/hydra-nav-state';
import MasqService from 'cio/services/masq';

const Validations = {
  useCase(value: string) {
    if (!value?.trim()) {
      return "Can't be blank";
    }

    return true;
  },
};

export default class GoalsController extends Controller {
  @controller('product-activation') activateController!: ProductActivationController;
  @service router!: RouterService;
  @service environment!: EnvironmentService;
  @service masq!: MasqService;

  validations: FormValidations;

  get product() {
    return this.activateController.product;
  }

  constructor() {
    super(...arguments);
    this.validations = FormValidations.create({
      validations: Validations,
      context: this,
      modelKey: 'activateController.formValues',
    });
  }

  get formValues() {
    return this.activateController.formValues.useCase;
  }

  get formValuesOther() {
    return this.activateController.formValues.useCaseDetail;
  }

  get formValidations() {
    return this.validations.errors.useCase;
  }

  get formValidationsOther() {
    return this.validations.errors.useCaseDetail;
  }

  submitTask = task(async (ev: MouseEvent) => {
    ev.preventDefault();
    try {
      await this.validations.validateModel();
    } catch (e) {
      // validation error, don't need to catch
      return;
    }

    try {
      await this.activateController.activateProductTask.perform(this.product);

      await announceRefreshAuth();

      if (this.product.name === ProductApp.DATA_PIPELINES) {
        announceHydraNavigate(`/workspaces/${this.environment.lastEnvironmentId}/pipelines/dashboard`);
      } else {
        this.router.transitionTo(`/workspaces/${this.environment.lastEnvironmentId}/journeys/setup-guide/sources`);
      }
    } catch {
      // will figure out error handling later - no info given for error messages yet
    }
  });

  skipTask = task(async (ev: MouseEvent) => {
    ev.preventDefault();

    this.activateController.setFormValue('useCase', 'none');
    this.submitTask.perform(ev);
  });

  @action
  onValueChange(field: keyof ProductActivationController['formValues'], value: string) {
    this.activateController.setFormValue(field, value);
    this.validations.validateAttribute(field);
  }
}

declare module '@ember/controller' {
  interface Registry {
    'product-activation.goals': GoalsController;
  }
}
